// Background Image upload disabled — mobile renders affirmations on a fixed pink
// gradient and never shows the image. Code kept commented for future reference.
// import { UploadDropzone } from "@/components/studio/upload-dropzone";
// import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { AffirmationLanguageVariantDraft } from "@/lib/schema";
// import { X } from "lucide-react";

interface AffirmationVariantFieldsProps {
  variant: AffirmationLanguageVariantDraft;
  onFieldChange: (
    field: keyof AffirmationLanguageVariantDraft,
    value: any,
  ) => void;
  // onFileUpload: (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   field: keyof AffirmationLanguageVariantDraft,
  // ) => void;
  // isUploading: boolean;
  isReadOnly?: boolean;
}

export function AffirmationVariantFields({
  variant,
  onFieldChange,
  // onFileUpload,
  // isUploading,
  isReadOnly = false,
}: AffirmationVariantFieldsProps) {
  return (
    <div className="space-y-4" data-testid="affirmation-variant-fields">
      <div className="space-y-2">
        <Label htmlFor="quoteText">Quote Text *</Label>
        <Textarea
          id="quoteText"
          value={variant.quoteText}
          onChange={(e) => onFieldChange("quoteText", e.target.value)}
          disabled={isReadOnly}
          placeholder="Enter the affirmation text..."
          rows={4}
          data-testid="input-quote-text"
        />
      </div>

      {/* Background Image upload — disabled, kept for future reference
      <div className="space-y-2">
        <Label>Background Image</Label>
        {variant.featuredImageUrl ? (
          <div className="relative w-full max-w-sm">
            <img
              src={variant.featuredImageUrl}
              alt="Background"
              className="rounded-md border w-full h-32 object-cover"
              data-testid="img-background"
            />
            {!isReadOnly && (
              <Button
                size="icon"
                variant="secondary"
                className="absolute top-1 right-1"
                onClick={() => onFieldChange("featuredImageUrl", null)}
                data-testid="button-remove-background"
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
        ) : (
          <UploadDropzone
            type="image"
            label="Upload Background Image"
            accept="image/*"
            onChange={(e) => onFileUpload(e, "featuredImageUrl")}
            isUploading={isUploading}
            disabled={isReadOnly}
            testId="input-upload-background"
          />
        )}
      </div>
      */}
    </div>
  );
}
